export default __webpack_public_path__ + "static/media/about-3.9d0ecb4d.jpg";